<h2 mat-dialog-title class="text-lg font-bold mb-1">Cambiar contraseña</h2>
<mat-dialog-content class="modal-content">
    <form [formGroup]="form">

        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Contraseña</mat-label>
            <input matInput [formControl]="password" aria-label="Contraseña"
                [type]="!hide ? 'password' : 'text'" minlength="3" maxlength="100">
            <mat-icon style="cursor: pointer;" class="text-muted" matSuffix (click)="hide = !hide">
                {{!hide ? 'visibility_off' : 'visibility'}}
            </mat-icon>
            <mat-error *ngIf="password.hasError('minlength')">
                La contraseña debe tener al menos 3 caracteres
            </mat-error>
            <mat-error *ngIf="password.hasError('hasNumber') || password.hasError('hasCapitalCase')">
                Debe incluir al menos un número y una letra mayúscula
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="fill" class="w-full">
            <mat-label>Repetir Contraseña</mat-label>
            <input matInput [formControl]="password_confirmation" name="password_confirmation" 
                [type]="!hidenew ? 'password' : 'text'">
            <mat-icon style="cursor: pointer;" class="text-muted" matSuffix (click)="hidenew = !hidenew">
                {{!hidenew ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-error *ngIf="password_confirmation.hasError('mismatchedPasswords')">
                La contraseña no coincide
            </mat-error>
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex justify-end">
    <button mat-button mat-dialog-close class="align-left">Cancelar</button>
    <button mat-raised-button color="primary" (click)="onSubmit()"
      >Guardar</button>
</mat-dialog-actions>